<template>
  <div id="app">
    <top-navigation></top-navigation>
    <side-bar></side-bar>
    <router-view/>
  </div>
</template>

<script>
  import TopNavigation from './components/TopNavigation.vue'
  import SideBar from './components/SideBar.vue'
export default {
  name: 'App',
  components:{
    TopNavigation,
    SideBar
  }
}
</script>

<style lang="less">
  @import "./assets/less/main.less";
</style>


// WEBPACK FOOTER //
// src/App.vue